/** One question and its answer, as plain text shown on the page and in the schema. */
export interface FaqEntry {
  q: string;
  a: string;
}

/** FAQPage JSON-LD whose answer text is the same string readers see. */
export const faqPageSchema = (entries: readonly FaqEntry[]) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: entries.map((entry) => ({
    '@type': 'Question',
    name: entry.q,
    acceptedAnswer: { '@type': 'Answer', text: entry.a },
  })),
});
